module.exports = __webpack_public_path__ + "img/diantu.12ca506d.png";